import React, { useEffect, useState } from 'react'
import { faFileExcel } from '@fortawesome/free-solid-svg-icons'
import ButtonIcon from 'components/ButtonComp'
import InputComp from 'components/InputComp'
import ModalComp from 'components/ModalComp'
import useForm from 'hooks/useForm'
import useLoading from 'hooks/useLoading'
import useOfflineDevices from 'hooks/useOfflineDevices'
import { IOfflineDevice } from 'models/OfflineDevice'
import * as XLSX from 'xlsx';

type Props = {
    onClose: () => void;
}

const DownloadXLSX: React.FC<Props> = ({ onClose }: Props) => {
    const [queryParams, setQueryParams] = useState({ startDate: '', endDate: '' });
    const hookLoading = useLoading({ defaultLoading: false });
    const hookForm = useForm({ startDate: '', endDate: '' });
    const { startDate, endDate } = queryParams;
    const hookOfflineDevicesExport = useOfflineDevices({ orderBy: "desc", startDate, endDate });

    useEffect(() => {
        setQueryParams({
            startDate: hookForm.form?.startDate,
            endDate: hookForm.form?.endDate,
        });
    }, [hookForm.form]);

    const handleDownloadXLSX = () => {
        hookLoading.start();
        try {
            const exportData = hookOfflineDevicesExport.data.map((item: IOfflineDevice) => ({
                'ID': item.id,
                'Dispositivo': item.device_type,
                'Elemento': item.description,
                'Estado': item.is_online ? "Online" : "Offline",
                'Fecha de Desconexión': item.created_at,
            }));

            // Create worksheet
            const ws = XLSX.utils.json_to_sheet(exportData);

            // Create workbook
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Datos de Alarmas');

            // Generate filename with timestamp
            const fileName = `offline_devices_${new Date().getTime()}.xlsx`;

            // Save the file
            XLSX.writeFile(wb, fileName);
        } catch (error) {
            console.error('Error al exportar a XLSX:', error);
        } finally {
            hookLoading.end();
        }
    }
    return (
        <ModalComp
            title="Descargar histórico de alarmas"
            width={400}
            onClose={onClose}
            footer={
                <div className="d-grid gap-2">
                    <ButtonIcon name='Descargar' icon={faFileExcel} variant='success' onClick={handleDownloadXLSX} disabled={hookOfflineDevicesExport.loading} />
                </div>
            }
        >
            <InputComp value={hookForm.form?.startDate} name='startDate' title='Fecha de inicio (opcional)' type='date' onChange={hookForm.handleChange} /><br />
            <InputComp value={hookForm.form?.endDate} name='endDate' title='Fecha de fin (opcional)' type='date' onChange={hookForm.handleChange} />
        </ModalComp>
    )
}

export default DownloadXLSX